<template>
    <div>
        <PageHeader>
            <template #navbar>
                <Navbar />
            </template>
            <template #pagetitle>
                <PageTitle :pageTitle="$t('pages.titles.about')" />
            </template>
        </PageHeader>
        <DemoProduct />
        <WhyChooseUs />
        <FreeTrial variant="light"/>
        <Footer />
    </div>
</template>

<script>
import Navbar from '../Layout/Navbar'
import PageTitle from '../Common/PageTitle'
import DemoProduct from '../AboutUs/DemoProduct'
import WhyChooseUs from '../AboutUs/WhyChooseUs'
import Footer from '../Layout/Footer'
import PageHeader from '../Layout/PageHeader';
import FreeTrial from '../Common/FreeTrial';

export default {
    name: 'AboutUsPage',
    components: {
        Navbar,
        PageTitle,
        PageHeader,
        DemoProduct,
        FreeTrial,
        WhyChooseUs,
        Footer,
    }
}
</script>
